module.exports = __webpack_public_path__ + "static/img/news9.c12f388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news9.jpg
// module id = ltAT
// module chunks = 1